import { formatNumber } from '@angular/common';
import { inject, Injectable, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

export type FileSizeUnit = 'B' | 'KB' | 'MB' | 'GB';
export enum FileSizeInBytes {
  GB = 1_073_741_824,
  MB = 1_048_576,
  KB = 1_024,
}

const FILE_SIZE_THRESHOLDS: { threshold: number; unit: FileSizeUnit }[] = [
  { threshold: FileSizeInBytes.GB, unit: 'GB' },
  { threshold: FileSizeInBytes.MB, unit: 'MB' },
  { threshold: FileSizeInBytes.KB, unit: 'KB' },
];

export function getFileSizeUnit(bytes: number): { size: number; unit: FileSizeUnit } {
  const match = FILE_SIZE_THRESHOLDS.find(({ threshold }) => bytes >= threshold);
  return match ? { size: bytes / match.threshold, unit: match.unit } : { size: bytes, unit: 'B' };
}

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'fileSize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  private readonly locale = inject(LOCALE_ID);

  transform(bytes: number | null | undefined, bytesLabel = 'B'): string | null {
    if (bytes == null || isNaN(bytes)) {
      return null;
    }
    const { size, unit } = getFileSizeUnit(bytes);
    if (unit === 'B') {
      return `${formatNumber(size, this.locale, '1.0-0')} ${bytesLabel}`;
    }
    return `${formatNumber(size, this.locale, '1.1-2')} ${unit}`;
  }
}
